"use client";

import { useIsLoggedInRetailerOrBrandPreview } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useAssignSettingFaireDirectSignupForVisitorXP } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFaireDirectCreditForVisitor";
import { useEffect } from "react";

import { BrandTokenOrBrandAlias } from "./faireDirectTypes";
import { useIsFaireDirectBrandForVisitor } from "./useIsFaireDirectBrandForVisitor";

export const useFaireDirectSignupXPAssignment = (
  params: BrandTokenOrBrandAlias
) => {
  const {
    isFaireDirectBrandForVisitor,
    isPending: isFaireDirectBrandForVisitorPending,
  } = useIsFaireDirectBrandForVisitor(params);
  const isLoggedInRetailerOrBrandPreview =
    useIsLoggedInRetailerOrBrandPreview();
  const assignSettingFaireDirectSignupForVisitorXP =
    useAssignSettingFaireDirectSignupForVisitorXP();

  useEffect(() => {
    if (
      isFaireDirectBrandForVisitorPending ||
      isLoggedInRetailerOrBrandPreview
    ) {
      return;
    }
    if (isFaireDirectBrandForVisitor) {
      assignSettingFaireDirectSignupForVisitorXP();
    }
  }, [
    isFaireDirectBrandForVisitor,
    isFaireDirectBrandForVisitorPending,
    isLoggedInRetailerOrBrandPreview,
    assignSettingFaireDirectSignupForVisitorXP,
  ]);
};
